/**
 * Stub: IconAnalysisView is not available in the admin app.
 * This stub exists so that @a7y/ui EngineDetailIcon can be resolved by the bundler.
 */
export const IconAnalysisView = () => null;
